import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'upsc-continuous-customs-bonds-application',
  templateUrl: './continuous-customs-bonds-application.component.html',
  styleUrls: ['./continuous-customs-bonds-application.component.scss']
})
export class ContinuousCustomsBondsApplicationComponent implements OnInit {

  ngOnInit(): void {
  }


  user = {
    LastName: '',
    FirstName: '',
    CompanyName: '',
    PhoneNumber: '',
    Email: '',
    Address1: '',
    City: '',
    StateProvinceRegion: '',
    ZipPostalCode: '',
    Country: '',
    MaximumInsuredValue: '',
    ProposalAgreement: '',
    MailingAddress: '',
    WpCCFullName: '',
    WpCCLastFour: '',
    UPSStoreNumber: '',
    WpCCAgreement: '',
    WpProfileID: '',
    WpProfileChange: '',
    agree: ''
  };

  onSubmit() {
    let FirstName = this.user.FirstName;
    let LastName = this.user.LastName;
    let CompanyName = this.user.CompanyName;
    let Country = this.user.Country;
    let PhoneNumber = this.user.PhoneNumber;
    let City = this.user.City;
    let StateProvinceRegion = this.user.StateProvinceRegion;
    let ZipPostalCode = this.user.ZipPostalCode;
    let MaximumInsuredValue = this.user.MaximumInsuredValue;
    let ProposalAgreement = this.user.ProposalAgreement;
    let MailingAddress = this.user.MailingAddress;
    let WpProfileChange = this.user.WpProfileChange;
    let agree = this.user.agree;
    let WpCCFullName = this.user.WpCCFullName;
    let WpCCLastFour = this.user.WpCCLastFour;
    let UPSStoreNumber = this.user.UPSStoreNumber;
    let WpCCAgreement = this.user.WpCCAgreement;
    let Email = this.user.Email;
    let emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;;
    let phoneRegex = /^[\+]?[0-9]{1,4}[\s\.\-]?[0-9]{1,4}[\s\.\-]?[0-9]{1,4}[\s\.\-]?[0-9]{1,9}$/;

    if (emailRegex.test(Email) && FirstName && phoneRegex.test(PhoneNumber) && LastName && CompanyName &&
      Country && City && StateProvinceRegion && ZipPostalCode && MaximumInsuredValue && ProposalAgreement && agree && WpProfileChange) {
      if (MailingAddress == '0') {
        alert('SUCCESS! Form has been submitted successfully');
      }
      else if (MailingAddress == '1' && WpCCFullName && WpCCLastFour && UPSStoreNumber && WpCCAgreement) {
        alert('SUCCESS! Form has been submitted successfully');
      } else {
        alert('Please fill in all fields!');
        return false;
      }
    }
    else {
      alert('Please fill in all fields!');
      return false;
    }
  }
}
